import { render } from "./SelectTemplates.vue?vue&type=template&id=133ce47e&scoped=true"
import script from "./SelectTemplates.vue?vue&type=script&lang=js"
export * from "./SelectTemplates.vue?vue&type=script&lang=js"

import "./SelectTemplates.vue?vue&type=style&index=0&id=133ce47e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133ce47e"]])

export default __exports__